import TableTemplate from "../../TableTemplate/tableTemplate";
import { getReferenceTable } from "../../../Requests/deltaHedgeMarketmaking";
import { CommonTableUI } from "../../TableTemplate/common";
import { useAppSelector } from "../../../App/hooks";
import { ITableReport } from "src/Interfaces/TableInterfaces";

const ReferenceTable = () => {
  const taskId = useAppSelector(
    (store) => store.deltaHedgeMarketmaking.clickedTaskTableRowValues?.id
  );
  if (!taskId) return <></>;

  return (
    <div className="overflow-auto order-table w-full">
      <TableTemplate<any, any>
        refreshTableTime={5000}
        withSort
        getDataTable={getReferenceTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="max-h-[300px]"
          />
        )}
        searchParameters={{ taskId }}
      />
    </div>
  );
};

export default ReferenceTable;
